import type { Role } from "../types";

// Both facilitators and teachers land on the PD-days list first — the
// facilitator's list is who they run, the teacher's is who they're
// enrolled in (see usePDDays). Kept in one place so every redirect, the
// header brand and the account menu agree.
export function landingPathFor(role: Role | undefined): string {
  return role === "facilitator" || role === "teacher" ? "/pd-days" : "/home";
}
